export const GroupUserRoleLabel = {
    1: 'English',
    2: 'French',
};

export const GroupUserRole = {
    MEMBER: 1,
    ADMIN: 2,
};
